import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { $verificationRequest, verificationRequestMounted } from './model'

export const useverificationRequest = () => {
  const { pathname } = useLocation()
  const verificationRequest = useStore($verificationRequest)

  React.useEffect(() => {
    verificationRequestMounted()
  }, [pathname])

  return verificationRequest
}
